import StudyTitleMapListPage from "@/pages/comp/plan/study/study_map/title_map";
import StuStudyMapListPage from "@/pages/comp/plan/study/study_map/stu_map";
import StudyMapHistoryPage from "@/pages/comp/plan/study/study_map/history";
import StudyMapMainPage from "@/pages/comp/plan/study/study_map/main";
import StudyListUnionPage from "@/pages/comp/plan/study/list_union";

const routerArr:object[] = [
  {
    path: "/comp/study/study_map/title_map",
    element: <StudyTitleMapListPage></StudyTitleMapListPage>,
  },
  {
    path: "/comp/study/study_map/stu_map",
    element: <StuStudyMapListPage></StuStudyMapListPage>,
  },
  {
    path: "/comp/study/study_map/history",
    element: <StudyMapHistoryPage></StudyMapHistoryPage>,
  },
  {
    path: "/comp/study/study_map/main",
    element: <StudyMapMainPage></StudyMapMainPage>,
  },
  {
    path: "/comp/study/study/list_union",
    element: <StudyListUnionPage></StudyListUnionPage>,
  },
];

export default routerArr;